<template>
  <div class="main">
    <section class="panel">
      <section class="panel panel-default" v-if="isAdmin('assist')">
        <header class="panel-heading" style="padding: 10px;">
          <div class="panel-actions" style="top: 7px;">
            <a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
          </div>
          <h4 class="panel-title">查詢條件</h4>
        </header>
        <div id="searchArea" class="panel-collapse collapse in">
          <div class="panel-body">
            <div class="row form-group">
              <div class="col-md-4 form-group">
                <label for="year" class="col-sm-4 col-xs-2">學年度</label>
                <div class="col-sm-8 col-xs-10">
                  <select id="year" name="year" v-model="qryParam.year" class="form-control">
                    <option value="">請選擇</option>
                    <option v-for="item in yearList" :key="item" :value="item">{{item}}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label for="smtr" class="col-sm-4 col-xs-2">學期</label>
                <div class="col-sm-8 col-xs-10">
                  <select id="smtr" name="smtr" v-model="qryParam.smtr" class="form-control">
                    <option value="">請選擇</option>
                    <option v-for="item in smtrList" :key="item" :value="item">{{item}}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label for="ssym" class="col-sm-4 col-xs-2">學制</label>
                <div class="col-sm-8 col-xs-10">
                  <select id="ssym" name="ssym" v-model="qryParam.ssym" class="form-control">
                    <option value="">請選擇</option>
                    <option v-for="(item,key) in ssymList" :key="key" :value="item.commCode">{{ item.commValue }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-md-4 form-group">
                <label for="dept" class="col-sm-4 col-xs-2">科系</label>
                <div class="col-sm-8 col-xs-10">
                  <select id="dept" name="dept" v-model="qryParam.dept" class="form-control">
                    <option value="">請選擇</option>
                    <option v-for="(item,key) in deptList" :key="key" :value="item.commCode">{{ item.commValue }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label for="drade" class="col-sm-4 col-xs-2">年級</label>
                <div class="col-sm-8 col-xs-10">
                  <select id="drade" name="drade" v-model="qryParam.drade" class="form-control">
                    <option value="">請選擇</option>
                    <option value="1">一年級</option>
                    <option value="2">二年級</option>
                    <option value="3">三年級</option>
                    <option value="4">四年級</option>
                    <option value="5">五年級</option>
                    <option value="6">六年級</option>
                    <option value="7">七年級</option>
                    <option value="8">八年級</option>
                    <option value="9">九年級</option>
                  </select>
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label for="class" class="col-sm-4 col-xs-2">班級</label>
                <div class="col-sm-8 col-xs-10">
                  <select id="class" name="class" v-model="qryParam.class" class="form-control">
                    <option value="">請選擇</option>
                    <option value="A">A班</option>
                    <option value="B">B班</option>
                    <option value="C">C班</option>
                    <option value="D">D班</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-md-4 form-group">
                <label for="account" class="col-sm-4 col-xs-2">學號</label>
                <div class="col-sm-8 col-xs-10">
                  <input id="account" name="account" type="text" v-model="qryParam.account" class="form-control" />
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label for="name" class="col-sm-4 col-xs-2">姓名</label>
                <div class="col-sm-8 col-xs-10">
                  <input id="name" name="name" type="text" v-model="qryParam.name" class="form-control" />
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label for="sex" class="col-sm-4 col-xs-2">性別</label>
                <div class="col-sm-8 col-xs-10">
                  <select id="sex" name="sex" v-validate="'required'" v-model="qryParam.sex" class="form-control">
                    <option value="">請選擇</option>
                    <option value="M">男</option>
                    <option value="F">女</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-md-4 form-group">
                <label for="reliefType" class="col-sm-4 col-xs-2">申請類別</label>
                <div class="col-sm-8 col-xs-10">
                  <select id="reliefType" name="reliefType" v-model="qryParam.reliefType" class="form-control">
                    <option value="">請選擇</option>
                    <option v-for="(item,key) in reliefTypeList" :key="key" :value="item.commCode">{{ item.commValue }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label for="state" class="col-sm-4 col-xs-2">資料合格</label>
                <div class="col-sm-8 col-xs-10">
                  <select id="state" name="state" v-model="qryParam.state" class="form-control">
                    <option value="">請選擇</option>
                    <option v-for="(item,key) in schreviewStateList" :key="key" :value="item.commCode">{{ item.commValue }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label for="lastState" class="col-sm-4 col-xs-2">最終狀態</label>
                <div class="col-sm-8 col-xs-10">
                  <select id="lastState" name="lastState" v-model="qryParam.lastState" class="form-control">
                    <option value="">請選擇</option>
                    <option value="1">合格</option>
                    <option value="2">不合格</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-md-4 form-group">
                <button @click="updateGrid(1)" class="btn s_btn_b">查詢</button>
                <button @click="clearSearchParam" class="btn s_btn_g">清除</button>
                <button @click="exportExcel" class="btn s_btn_b">匯出</button>
              </div>
            </div>
            <hr/>
            <h4 style="font-weight: bold">{{lastestSmtrState.smtr}} 學期申請狀態</h4>
            <div class="col-md-12">
              <div class="col-md-2">
                <h5>全部件數 : {{lastestSmtrState.total}} </h5>
              </div>
              <div class="col-md-2">
                <h5>待審核件數 : {{lastestSmtrState.pending}} </h5>
              </div>
              <div class="col-md-2">
                <h5>合格件數 : {{lastestSmtrState.approval}} </h5>
              </div>
              <div class="col-md-2">
                <h5 >不合格件數 : {{lastestSmtrState.reject}} </h5>
              </div>
              <div class="col-md-2">
                <h5>待補件件數 : {{lastestSmtrState.incomplete}} </h5>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="panel panel-default">
        <div class="tab-content">
          <div class="tab-pane fade in show" role="tabpanel" aria-labelledby="vacation-tab">
            <div class="row form-group" v-if="JSON.stringify(this.sessionData) != '{}'">
              <div class="col-md-12 text-left form-inline">
                <button @click="gotoView('relief.apply.new')" class="btn s_btn_o">新增</button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <table class="table table-no-more table-bordered table-striped mb-none" >
                  <thead>
                  <tr >
                    <th class="text-center" width="5%">序號</th>
                    <th class="text-center" width="7.5%">申請學年度</th>
                    <th class="text-center" width="5%">學期</th>
                    <th class="text-center" width="12.5%">學號</th>
                    <th class="text-center" width="15%">姓名</th>
                    <th class="text-center" width="20%">優待類別</th>
                    <th v-if="isAdmin('assist')" class="text-center" width="12.5%">資料合格</th>
                    <th v-if="!isAdmin('assist')" class="text-center" width="20%">備註</th>
                    <th v-if="isAdmin('assist')" class="text-center" width="10%">最終狀態</th>
                    <th v-if="isAdmin('assist')" class="text-center" width="12.5%">備註</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, index) in reliefApplyList" :key="index">
                    <td data-title="序號" class="text-center" >{{index + 1}}</td>
                    <td data-title="申請學年度" class="text-center" >{{item.smtr.substr(0, 3)}}</td>
                    <td data-title="學期" class="text-center" >{{item.smtr.substr(3, 1)}}</td>
                    <td data-title="學號" class="text-center" >{{item.account}}</td>
                    <td data-title="姓名" class="text-center" >
                      <a class="btn-link" style="cursor: pointer;" @click="gotoView('relief.apply.edit', {reliefApplyId: item.id, isFromIdnoSearch: isFromIdnoSearch})">{{item.name}}</a>
                    </td>
                    <td data-title="優待類別" class="text-center" >{{item.reliefTypeStr}}</td>
                    <td v-if="isAdmin('assist')" data-title="審核狀態" class="text-center" >{{item.schReviewStateStr}}</td>
                    <td v-if="!isAdmin('assist')" data-title="備註" class="text-center" >{{item.schReviewState === '0' ? item.schReviewStateStr : ''}}</td>
                    <td v-if="isAdmin('assist')" data-title="最終狀態" class="text-center" >{{item.moeReviewMinistry == "F" ? "合格" : !!item.moeReviewMinistry ? "不合格" : ""}}</td>
                    <td v-if="isAdmin('assist')" data-title="備註" class="text-center" >{{item.isAppliedWeak ? "已申請本學年弱勢助學金" : ""}}</td>
                  </tr>
                  </tbody>
                </table>

              </div>
              <div class="col-md-12">
                <div class="text-center" v-if="isAdmin('assist')">
                  <pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      qryParam:{
        year: "",
        smtr: "",
        ssym: "",
        dept: "",
        drade: "",
        class: "",
        account: "",
        name: "",
        sex: "",
        reliefType: "",
        state: "",
        withoutDraft: false,
        idNo: "",
        lastState: "",
      },
      lastestSmtrState: {
        smtr: "",
        total: 0,
        pending: 0,
        approval: 0,
        reject: 0,
        incomplete: 0
      },
      reliefApplyList: [],
      page: 1,
      totalPage: 1,
      // 下拉選單來源
      ssymList: [],
      deptList: [],
      reliefTypeList: [],
      schreviewStateList: [],
      yearList: [],
      smtrList: [],

      // 透過身分證字號查詢進入
      isFromIdnoSearch: false,
    };
  },
  mounted() {
    this.pageInit();
  },
  methods: {
    pageInit() {
      if(this.isAdmin('assist')) {
        let api = "/api/relief/listInit";
        this.$axios.get(api).then(res => {
          this.ssymList = res.data.data.selectList.ssym
          this.deptList = res.data.data.selectList.dept
          this.reliefTypeList = res.data.data.selectList.reliefType
          this.schreviewStateList = res.data.data.selectList.reviewState
          res.data.data.selectList.smtr.map((item) => {
            this.yearList.push(item.substr(0, 3));
            this.smtrList.push(item.substr(3, 1));
          });
          this.yearList = this.yearList.filter(this.uniqueList).sort().reverse();
          this.smtrList = this.smtrList.filter(this.uniqueList).sort();
        });

        api = "/api/relief/getLastestSmtrState";
        this.$axios.get(api).then(res => {
          this.lastestSmtrState = res.data.data;
        });

        // 套用查詢設定
        const storeQryParam = JSON.parse(this.getStore(`${this.$route.name}.qryParam`));
        if(storeQryParam != null) {
          this.qryParam = storeQryParam;
        }
        const storePage = this.getStore(`${this.$route.name}.page`);
        if(storePage != null) {
          this.page = storePage;
        }

      }
      else if(JSON.stringify(this.sessionData) != '{}'){
        this.qryParam.account = this.sessionData.account;
        this.qryParam.withDraft = true;
      } else {
        this.isFromIdnoSearch = true;
        this.qryParam.idNo = JSON.parse(this.getStore(this.$route.name)).idNo
      }

      this.updateGrid(this.page)
    },
    updateGrid(page = 1) {
      //更新Grid 必需
      this.page = page;

      const api = "/api/relief";
      const query = new URLSearchParams({
        ...this.qryParam,
        page: this.page,
        pageSize: 10,
      }).toString();
      this.$axios.get(`${api}?${query}`).then(resp =>{
        if(resp.data.status === "success") {
          this.reliefApplyList = resp.data.data.rows;
          this.totalPage = Math.ceil(resp.data.data.rowNum / resp.data.data.pageSize);
          this.page = resp.data.data.page;
        } else {
          bootbox.alert(resp.data.msg);
        }
      });
    },
    exportExcel(){
      const api = "/api/relief/export";
      const query = new URLSearchParams({
        ...this.qryParam,
        page: 0,
        pageSize: 0,
      }).toString();
      this.$axios.get(`${api}?${query}`, {
        responseType: 'blob'
      }).then(resp =>{
        const url = window.URL.createObjectURL(new Blob([resp.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `學雜費減免申請資料_${this.customFormatter(new Date(),"YYYYMMDD")}.xlsx`);
        document.body.appendChild(link);
        link.click();
      });
    },
    clearSearchParam(){
      this.qryParam = {
        year: "",
        smtr: "",
        ssym: "",
        dept: "",
        drade: "",
        class: "",
        account: "",
        name: "",
        sex: "",
        reliefType: "",
        state: "",
        withoutDraft: false,
        idNo: "",
        lastState: "",
      };
      this.removeStore(`${this.$route.name}.qryParam`);
      this.removeStore(`${this.$route.name}.page`);
    },
    uniqueList(value, index, self) {
      return self.indexOf(value) === index;
    }
  },
  beforeRouteLeave(to, from, next) {
    //保留查詢設定
    if(to.name.startsWith("relief.apply.")) {
      this.setStore(`${this.$route.name}.qryParam`, this.qryParam);
      this.setStore(`${this.$route.name}.page`, this.page);
    } else {
      this.removeStore(`${this.$route.name}.page`);
      this.removeStore(`${this.$route.name}.qryParam`);
    }

    this.removeStore(this.$route.name);
    next();
  }
};
</script>

